import React from 'react';
import ReactTooltip from 'react-tooltip';

import { FaLock } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

type TitleProps = {
  title: string;
  isPrivate: boolean;
};

const Title: React.FC<TitleProps> = ({ title, isPrivate }) => {
  const { t } = useTranslation(['events']);

  return (
    <h1
      className="pt-12 text-2xl font-semibold flex items-center col-span-3"
      data-testid="event-title"
    >
      {title}
      {isPrivate && (
        <>
          <span
            data-tip
            data-for="private-event-tooltip"
            className="text-gray-500 ml-3 text-xl"
            data-testid="private-icon"
          >
            <FaLock />
          </span>
          <ReactTooltip id="private-event-tooltip" place="top" effect="solid">
            <p className="text-sm">{t('events:eventDetails.privateEvent')}</p>
          </ReactTooltip>
        </>
      )}
    </h1>
  );
};

export default Title;
